"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var tiny_invariant_1 = __importDefault(require("tiny-invariant"));
var AccessAuthenticationPageStateContext_1 = require("./AccessAuthenticationPageStateContext");
var identityService_1 = require("./identityService");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var styles = __importStar(require("./AccessAuthentication.css"));
var AccessAuthenticationTelemetry_1 = require("./AccessAuthenticationTelemetry");
var ValidateStrings_1 = require("@CommonFrontendBackend/Utils/ValidateStrings");
var validator_1 = __importDefault(require("validator"));
var VerificationForm = function (_a) {
    var submitUrl = _a.submitUrl, triggerPulse = _a.triggerPulse, setPageUnlocked = _a.setPageUnlocked, requestName = _a.requestName, requestEmail = _a.requestEmail, validateEmail = _a.validateEmail;
    var accessAuthContext = (0, AccessAuthenticationPageStateContext_1.useAccessAuthPageState)();
    var telemetry = (0, AccessAuthenticationTelemetry_1.useAccessAuthTelemetry)();
    var handleSubmit = function (values) { return __awaiter(void 0, void 0, Promise, function () {
        var email, name, result, result_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    triggerPulse();
                    email = values.email, name = values.name;
                    (0, tiny_invariant_1.default)(typeof name === "undefined" || typeof name === "string", "Name must a string");
                    (0, tiny_invariant_1.default)(typeof email === "undefined" || typeof email === "string", "Email must a string");
                    if (!validateEmail) return [3, 2];
                    (0, tiny_invariant_1.default)(typeof email === "string", "Email must a string");
                    return [4, (0, identityService_1.submitEmailValidateRequest)({ submitUrl: submitUrl, email: email, name: name })];
                case 1:
                    result = _a.sent();
                    if (result.ok !== true) {
                        if (result.error === identityService_1.SubmitErrors.NoAccess) {
                            telemetry.track("Email Access Auth Viewed", { stage: "no access" });
                        }
                        return [2, (0, kaleidoscope_1.createFormSubmitErrorObject)(result.error)];
                    }
                    return [2, accessAuthContext.setPageState({
                            page: "email was sent",
                            verificationData: { email: email, name: name },
                        })];
                case 2: return [4, (0, identityService_1.softIdentify)({ submitUrl: submitUrl, email: email, name: name })];
                case 3:
                    result_1 = _a.sent();
                    if (result_1.ok !== true) {
                        return [2, (0, kaleidoscope_1.createFormSubmitErrorObject)(result_1.error)];
                    }
                    setPageUnlocked(true);
                    setTimeout(function () {
                        triggerPulse();
                        window.location.href = result_1.redirectUrl;
                    }, kaleidoscope_1.AnimationDuration.Long + 1000);
                    _a.label = 4;
                case 4: return [2];
            }
        });
    }); };
    return (react_1.default.createElement(kaleidoscope_1.FormComponent, { onSubmit: handleSubmit, className: styles.form },
        react_1.default.createElement(kaleidoscope_1.FormContext.Consumer, null, function (context) { return (react_1.default.createElement(react_1.default.Fragment, null,
            requestName && (react_1.default.createElement(kaleidoscope_1.FormTextInput, { name: "name", label: "Name", placeholder: "Firstname Lastname", validate: function (value) {
                    if (!value) {
                        return identityService_1.SubmitErrors.NameEmpty;
                    }
                    var validateName = (0, ValidateStrings_1.checkBasicText)(value, { allowUrlsOrEmails: true });
                    if (validateName.valid === false) {
                        return "A name ".concat(validateName.error);
                    }
                } })),
            (requestEmail || validateEmail) && (react_1.default.createElement(kaleidoscope_1.FormTextInput, { inputMode: "email", name: "email", label: "Email", placeholder: "you@email.com", validate: function (value) {
                    if (!value) {
                        return identityService_1.SubmitErrors.EmailEmpty;
                    }
                    var validateEmail = (0, ValidateStrings_1.checkBasicText)(value, { allowUrlsOrEmails: true });
                    if (validateEmail.valid === false) {
                        return identityService_1.SubmitErrors.EmailInvalid;
                    }
                    if (!validator_1.default.isEmail(value)) {
                        return identityService_1.SubmitErrors.EmailInvalid;
                    }
                } })),
            react_1.default.createElement(kaleidoscope_1.Expandable, { expanded: !!(context === null || context === void 0 ? void 0 : context.submitError) }, function (_a) {
                var expandableElementRef = _a.expandableElementRef;
                return (react_1.default.createElement("div", { ref: expandableElementRef },
                    react_1.default.createElement(kaleidoscope_1.Alert, { heading: (context === null || context === void 0 ? void 0 : context.submitError) === identityService_1.SubmitErrors.NoAccess ? "No Access" : "Error", alertType: kaleidoscope_1.AlertType.Error }, context === null || context === void 0 ? void 0 : context.submitError)));
            }),
            react_1.default.createElement(kaleidoscope_1.FormSubmitButton, { width: "full" },
                react_1.default.createElement(kaleidoscope_1.Text, { size: "s", strong: true, className: styles.primaryButtonText }, "Continue")))); })));
};
exports.default = VerificationForm;
